var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0E97E6CE-3C93-4B7D-8CAB-447E8D9D66A2@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Info",
    transform: "translate(-1253.000000, -699.000000)",
    fill: "#2774AE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(36.000000, 598.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(29.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1196,20.8571429 C1196.31558,20.8571429 1196.57143,21.1769524 1196.57143,21.6734694 L1196.57143,25.755102 C1196.57143,26.251619 1196.31558,26.5714286 1196,26.5714286 C1195.68442,26.5714286 1195.42857,26.251619 1195.42857,25.755102 L1195.42857,21.6734694 C1195.42857,21.1769524 1195.68442,20.8571429 1196,20.8571429 Z M1196,17.2 C1196.44113,17.2 1196.8,17.55904 1196.8,18.00036 C1196.8,18.44128 1196.44113,18.8 1196,18.8 C1195.55887,18.8 1195.2,18.44128 1195.2,18.00036 C1195.2,17.55904 1195.55887,17.2 1196,17.2 Z M1196,14 C1200.4112,14 1204,17.5888485 1204,22.0000485 C1204,26.4112485 1200.4112,30 1196,30 C1191.5888,30 1188,26.4112485 1188,22.0000485 C1188,17.5888485 1191.5888,14 1196,14 Z M1196,28.4 C1199.52896,28.4 1202.4,25.5290074 1202.4,22.0000474 C1202.4,18.4710874 1199.52901,15.6 1196,15.6 C1192.47099,15.6 1189.6,18.4710874 1189.6,22.0000474 C1189.6,25.5290074 1192.47099,28.4 1196,28.4 Z",
    id: "Path-3-Copy-4"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBlue);
export default __webpack_public_path__ + "static/media/icon-info-blue.3ea70ca01c8ae01842b4ff28d77f2ea3.svg";
export { ForwardRef as ReactComponent };